import { Injectable, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfirmationService, Confirmation } from 'primeng/api';
import { CONFIRM_PDIALOG_KEY } from '../../component/confirmdialog/his-confirm-dialog.component';

/**
 * This service must be used instead of primeng's ConfirmationService in order to
 * prevent XSS attacks in confirmation dialogs.
 * See https://hiszilla.his.de/hiszilla/show_bug.cgi?id=242005
 */
@Injectable({providedIn: 'root'})
export class HisConfirmationService {
    private confirmationService = inject(ConfirmationService);
    private sanitizer = inject(DomSanitizer);


    public confirm( confirmation: Confirmation ) {
        confirmation.key ??= CONFIRM_PDIALOG_KEY;

        // console.log('original: ', confirmation.message);
        // console.log('escaped:  ', this.escape(confirmation.message));
        // console.log('sanitized:', this.sanitize(confirmation.message));
        confirmation.message = this.escape( confirmation.message );
        // Sanitizing e.g. replaces "Möchten Sie fortfahren?" by "M&#246;chten Sie fortfahren?"
        // We do not want that.
        this.confirmationService.confirm( confirmation );
    }
    
    public close(){
        this.confirmationService.close();
    }

    private escapeAndSanitize( str: string ): string {
        return this.escape( this.sanitize( str ) );
    }

    private sanitize( str: string ): string {
        return str ? this.sanitizer.sanitize( SecurityContext.HTML, str ) : null;
    }

    private escape( str: string ): string {
        return str ? str.replace( /&/g, '&amp;' ).replace( /</g, '&lt;' ).replace( />/g, '&gt;' )
            .replace( /"/g, '&quot;' ).replace( /'/g, '&#039;' ) : null;
        // From https://stackoverflow.com/questions/38577347/manually-sanitize-a-string:
        // "The HTML escaping function used above escapes the same chars as angular code does
        // (unfortunately, their escaping function is not public, so we can't use it)"
    }
}
